<template>
  <div>
    <div ref="sliderContainer" class="slider-container" data-aos="fade-up">
      <SsrCarousel
        ref="slider"
        v-model="carouselIndex"
        class="main-slider"
        show-arrows
        show-dots
        loop
        :autoplay-delay="6"
        :slides-per-page="1"
        :responsive="[
          {
            minWidth: 768,
            slidesPerPage: 3,
          },
        ]"
        paginate-by-slide
        :gutter="0"
        center
      >
        <div v-for="(image, i) in images" :key="`slider__${i}`" class="slide-container glightbox">
          <AppImage
            :key="`slider-image__${i}`"
            class="carousel-image"
            :class="{ '--active': i === carouselIndex }"
            :image="image.srcset"
            :alt="image.altText"
            :blurred-preview="image.blurred"
            @click.native="openLightbox(i)"
          />
        </div>

        <template #back-arrow>
          <SliderArrowIcon />
        </template>

        <template #next-arrow>
          <SliderArrowIcon />
        </template>

        <template #dot>
          <div class="custom-dot">
            <div class="pagination-dot"></div>
          </div>
        </template>
      </SsrCarousel>
    </div>
  </div>
</template>

<script>
import PhotoSwipe from 'photoswipe/dist/photoswipe.esm'
import SsrCarousel from 'vue-ssr-carousel'
import 'vue-ssr-carousel/index.css'
import 'photoswipe/dist/photoswipe.css'

export default {
  components: {
    SliderArrowIcon: () => import('@/components/icons/SliderArrowIcon'),
    AppImage: () => import('@/components/common/AppImage'),
    SsrCarousel,
  },
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    imagesForLightbox: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      carouselIndex: 0,
      lightboxIndex: null,
      lightbox: null,
      options: {
        dataSource: this.imagesForLightbox,
        index: 0,
        padding: { top: 12, bottom: 12, left: 12, right: 12 },
        counter: false,
      },
    }
  },
  beforeDestroy() {
    if (this.lightbox) {
      this.lightbox?.close()
      this.lightbox = null
    }
  },
  methods: {
    openLightbox(i) {
      if (this.lightbox) this.lightbox?.close()
      this.options.index = i
      this.carouselIndex = i
      this.lightbox = new PhotoSwipe(this.options)
      this.lightbox.init()
      this.lightbox.on('change', () => {
        this.carouselIndex = this.lightbox?.currIndex
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/single-portfolio/Slider';
</style>
